import { IProfile, getPrimaryAddressFromProfile } from '@comptia-sso/core';
import isEmpty from 'lodash/isEmpty';

export const needsAdditionalDetails = (profile?: IProfile): boolean =>
  isEmpty(profile?.company) ||
  isEmpty(getPrimaryAddressFromProfile(profile)?.country);
